import { Parsing } from "./parsing";
import { cr } from "fire-wind-water";

class SkStyle extends Parsing {
  private exp: any;
  private cssText: string;

  constructor(
    private elem: HTMLElement,
    private attr: string,
    private module: any
  ) {
    super();
    this.exp = Parsing.expression(attr);
    this.cssText = this.elem.style.cssText;
    this.update();
  }

  private update(): void {
    const value = this.exp.call(this.module);
    if (cr.isString(value)) {
      this.elem.style.cssText = this.cssText + value;
    } else if (cr.isPlainObject(value)) {
      this.elem.style.cssText = "";
      const style: string[] = [];
      cr.each(value, (d, k) => {
        style.push(`${k}: ${d};`);
      });
      this.elem.style.cssText = this.cssText + style.join(";");
    }
  }
}

export { SkStyle };
